import { CircularProgress } from "@mui/material";

function Loading() {
  return (
    <div className="flex items-center justify-center h-screen">
      {/* <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-opacity-25"></div> */}
      <CircularProgress />
    </div>
  );
}

export default Loading;
